export default __webpack_public_path__ + "static/media/Map1-1.11ab79ac.png";